<template>
  <div>
    <a-dialog v-model="isDialogOpen" persistent scrollable max-width="500px">
      <v-card flat>
        <v-toolbar color="#CFDDE6" flat dark height="48px">
          <span>{{ currentLCATab === 0 ? $t("business.lblDataManagementByConsolidated") :
            $t("business.lblDataManagementByCompany") }}</span>
          <v-spacer></v-spacer>
          <CloseIcon @click="close" />
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" style="padding: 0 !important">
                <span>
                    <a-data-table
                      v-model="selected"
                      :headers="headers"
                      :items="companies"
                      item-key="Project(Code)"
                      :key="render"
                      :items-per-page="-1"
                      hide-default-footer
                      show-select
                      dense
                      fixed-header
                      height="auto"
                      mobile-breakpoint="0"
                      :no-data-text="$t('noData')"
                      :no-results-text="$t('emptySearchRecords')"
                      :loading="isLoading"
                      :must-sort="true"
                    >
                      <!-- Column: Project(Code) -->
                      <template v-slot:[`item.Project(Code)`]="{ item }">
                        <span >{{ item["Project(Code)"] }}</span>
                      </template>

                      <!-- Column: Project(Name) -->
                      <template v-slot:[`item.Project(Name)`]="{ item }">
                        <span>{{ item["Project(Name)"] }}</span>
                      </template>
                    </a-data-table>
                  </span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="flex justify-end">
          <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn small v-bind="attrs" v-on="on" class="primaryDark" @click="confirmClearData"
              :disabled="isLoading || selected.length == 0">
              {{ $t("btnDelete") }}
            </a-btn>
          </template>
          <span>{{ $t("btnDelete") }}</span>
        </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn small v-bind="attrs" v-on="on" class="secondary ml-2" @click="close" :disabled="isLoading">{{
                $t("btnClose") }}</a-btn>
            </template>
            <span>{{ $t("btnClose") }}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
      <confirm-dialog ref="confirmClear"></confirm-dialog>
    </a-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ConfirmDialog from "../ConfirmDialog.vue";
import ACheckbox from "../../wrapper-component/ACheckbox.vue";

export default {
  name: "DataManagementDialog",
  components: {
    ConfirmDialog,
    ACheckbox
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    consolidatedCompanies: {
      type: Array,
      default: () => [],
    },
    companyTabCompanies: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    ...mapState({
      currentLCATab: (state) => state.agenda.currentLCATab,
    }),
    currentCompanies() {
      return this.currentLCATab ? this.companyTabCompanies : this.consolidatedCompanies;
    },
    headers() {
    return [
      {
        text: this.$t('lcaMissingColumns.Project(Code)'),
        value: "Project(Code)",
        sortable: true,
      },
      {
        text: this.$t('lcaMissingColumns.Project(Name)'),
        value: "Project(Name)",
        sortable: true,
      },
    ];
  }

  },
  data() {
    return {
      isLoading: false,
      valid: true,
      render: 0,
      companies: [],
      companyList: [],
      email: '',
      emailErrors: [],
      isDialogOpen: this.isOpen,
      selected: [],
      selectAll: false,
      currentLocale: this.$i18n.locale, 
      
    };
  },
  mounted() {
    this.isDialogOpen = this.isOpen;
  },
  beforeDestroy() {
    this.$root.$off('languageChanged', this.forceRerender);
  },
  watch: {
    isOpen() {
      this.isDialogOpen = this.isOpen;
      if(this.isOpen)
      {
        this.updateCompanies();
      }
    },
    selected(val) {
      this.selectAll = val.length === this.companies.length;
    },
    currentCompanies: {
      handler() {
        this.updateCompanies();
      },
      deep: true
    },
    isDialogOpen(newVal) {
      if (newVal) {
        this.updateCompanies();
        this.selected = [];
      }
    },
    '$i18n.locale': {
      handler(newLocale) {
        this.currentLocale = newLocale;
        this.$nextTick(() => {
          this.forceRerender();
        });
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      deleteLCARecords: "agenda/deleteLCARecords",
    }),
    updateCompanies() {
      this.companies = this.currentLCATab ? [...this.companyTabCompanies] : [...this.consolidatedCompanies];
      this.selected = [];
      this.selectAll = false;
    },
    forceRerender() {
      this.render++;
    },
    close() {
      this.isDialogOpen = false;
      this.$emit("update:isOpen", false);
      if (this.$refs.refDeleteLCAForm) {
        this.$refs.refDeleteLCAForm.resetValidation();
      }
      this.email = '';
      this.emailErrors = [];
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selected = [...this.companies];
      } else {
        this.selected = [];
      }
    },
    onEmailInput() {
      if (this.emailErrors.length) {
        this.validateEmailField();
      }
    },
    validateEmailField() {
      const errors = [];
      if (!this.email || !this.email.trim()) {
        errors.push(this.$t("ruleEmailReq"));
      } else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        errors.push(this.$t("ruleEmailvalid"));
      }
      this.emailErrors = errors;
      return errors.length === 0;
    },
    async confirmClearData() {
      if (
        await this.$refs.confirmClear.open(
          this.$t("lblDeleteConfirmation"),
          this.currentLCATab === 0 ? this.$t("business.msgClearLCARecordsByConsolidated") : this.$t("business.msgClearLCARecordsByCompany"),
          { yesNoButtons: true }
        )
      ) {
        this.clearLCARecords();
      }
    },
    async clearLCARecords() {
      try {
        this.$emit("update:loading", true);
        const projectCodes = Array.isArray(this.selected)
          ? JSON.stringify(this.selected.map(item => String(item["Project(Code)"])))
          : [];
        const requestBody = this.currentLCATab === 0 ? { report_type: "lca-650", project_codes: projectCodes } : { report_type: "lca-660", project_codes: projectCodes }
        await this.deleteLCARecords(requestBody);
        this.$emit("update:isOpen", false);
        this.$emit("onDelete", true);
      } catch (error) {
        this.$emit("update:loading", false);
      } finally {
        this.$emit("update:loading", false);
        if (this.$refs.refDeleteLCAForm) {
          this.$refs.refDeleteLCAForm.resetValidation();
        }
        this.email = '';
        this.emailErrors = [];
      }
    },
  },
};
</script>
<style scoped>
.v-toolbar /deep/ .v-toolbar__content {
  color: var(--v-darkCharcoal-base);
  font-family: Noto Sans JP;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
}

::v-deep .v-data-table-header th {
  border-right: 1px solid white;
}

::v-deep .v-data-table-header {
  border-right: none;
}
.v-data-table--fixed-header > .v-data-table__wrapper{
  overflow-y: hidden;
}
</style>